var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center flex-column",staticStyle:{"height":"300px","width":"500px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }